@if (showPortalUI) {
<header id="header" class="header">
  <nav class="navbar fixed-top navbar-expand-lg scrolling-navbar navbgColor">
    <img class="ms-3 logo navbar-brand" href="" src="./assets/Images/Header/Accenture1.png">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item  waves-light headerDesc ripple">
          <span>
            <a class="nav-linkCompany cursor text-uppercase text-white" href="#" style="text-decoration: none;">
              <strong>{{CompanyTitle}}</strong>
              <span class="sr-only">(current)</span></a>
          </span>
        </li>
      </ul>

      <ul class="me-5 navbar-nav ms-auto nav-flex-icons">
        <li class="nav-item">
          <a class="nav-link" text-white href="#">
            Hi, <strong>{{UserName}}</strong></a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle cursor" id="navbarDropdownMenuLink-333" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <mat-icon fas icon="user" style="font-size:30px;">person</mat-icon>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-default  align-items-center"
            aria-labelledby="navbarDropdownMenuLink-333">
            <!-- @if (showAdmin) {
            <a class="d-flex align-items-center cursor">
              <a class="alink active" data-toggle="modal" data-target="#modalAdmin" (click)="LoadAdmin();">
                <h6><span>Admin</span> </h6>
              </a>
            </a>
            } -->
            @if (UserDownloadAccess) {
            <a class="d-flex align-items-center cursor">
              <a class="alink active" data-toggle="modal" data-target="#modalSpoolDownload" (click)="spoolDownload();">
                <h6><span>Spool Download</span> </h6>
              </a>
            </a>
            }
            <!-- @if (showDocketUpload) {
            <a class="d-flex align-items-center cursor">
              <a class="alink active" data-toggle="modal" data-target="#docketUpload" (click)="LoadDocketUpload();">
                <h6><span>Docket Upload</span> </h6>
              </a>
            </a>
            } -->
            <!-- <a class="d-flex align-items-center cursor">
              <a class="alink active" data-toggle="modal" data-target="#projectPermission"
                (click)="LoadProjectPermission();">
                <h6><span>Project Permission</span> </h6>
              </a>
            </a> -->
            <a class=" d-flex align-items-center cursor">
              <i class="fas fa-sign-out-alt iconColor margin"></i>
              <a class="alink active" (click)="logOut()">
                <h6><span>LogOut</span> </h6>
              </a>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>
}